@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ label() }}</label>
  <lib-rate-input
    [error]="showError"
    [controlId]="inputId"
    [formControl]="inputFormControl()"
    [autocomplete]="autocomplete()"
    [placeholder]="placeholder() ?? ''"
    [allowNegative]="allowNegative()">
  </lib-rate-input>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
      {{ hintText() }}
    </div>
  }
  @if (showError) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>
